import {Component, OnInit} from "@angular/core";
import {CorePage} from "../core-page/core.page";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {ActivatedRoute, Router} from "@angular/router";
import {SignUpService} from "../../../rg/service/sign-up.service";
import {CoreApiService} from "../../service/core-api.service";
import {RegistrationRequestOtpDto} from "../../../rg/types/registration.types";


@Component({
  selector: 'forget-password-page',
  templateUrl: './forget-password.page.html',
  styleUrls: ['forget-password.page.scss']
})
export class ForgetPasswordPage extends CorePage implements OnInit {

  override defaultLabel: string = "Registration";
  activeStep: number = 1;
  formGroup: FormGroup | undefined;

  constructor(
    protected override route: ActivatedRoute,
    protected router: Router,
    protected signUpService: SignUpService,
    protected formBuilder: FormBuilder,
    protected coreApiService: CoreApiService,
  ) {
    super(route);
  }

  override ngOnInit() {
    this.initComponent();
  }


  initComponent() {
    this.createFormGroup();
    this.refreshComponent();
  }

  refreshComponent() {
    this.initialized = true;
  }

  createFormGroup() {
    this.formGroup = this.formBuilder.group({
      anyUserText: [''],
      selectedOption: [''],
      deviceInfo: [''],
      password: ['', Validators.required],
      otp: [''],
      confirmPassword: ['', Validators.required],
    });

    const dto: RegistrationRequestOtpDto = {
      deviceInfo: this.coreApiService.getDeviceInfo()
    }
    this.formGroup.patchValue(dto);

  }

  handleStepComplete(completedStep: number) {
    this.activeStep = completedStep + 1;
    //navigate to next step
    if (this.activeStep > 3) {
      this.router.navigate(['/login']);
    }
  }

}
